export default "__VITE_ASSET__DL$kIsGu__"